/****************************************************
 * Module Name:  addCertificateModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, Button, TextField, Typography, Checkbox } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import Select from "react-select";

const AddCertificateModal = ({
  show,
  setShow,
  handleValidation,
  handleSave,
  loading,
  labName,
}) => {
  const [ids, setIds] = useState("");
  const [priority, setPriority] = useState(Constants.IGI_PRIORITIES[1]);
  const [showError, setShowError] = useState(false);
  const [forceReFetch, setForceReFetch] = useState(false);
  let certificateIds = ids.split(",");

  const saveHandler = () => {
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(certificateIds)) {
          if (labName === "igi")
            handleSave(certificateIds, priority.value, ids, forceReFetch);
          else
            handleSave(certificateIds, ids);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(certificateIds, ids);
      }
    }
  };
  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <CommonSnackbar
        show={showError}
        message={
          <Box>
            Add certificateIds validation Failed
            <br /> Please enter complete data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Add Certificate
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box
            sx={{
              display: "flex",
              width: "90%",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                alignSelf: "center",
                width: "20%",
                mt: 1,
              }}
            >
              <Form.Label className="mt-2">
                Certificate ID: <sup style={{ color: "red" }}>*</sup>
              </Form.Label>
            </Box>
            <Box
              sx={{
                alignSelf: "center",
                width: "80%",
                mt: 1,
              }}
            >
              <TextField
                id="outlined-multiline-static"
                label="Comma seperated Certificate Ids (required)"
                multiline
                fullWidth
                rows={4}
                value={ids}
                onChange={(e) =>
                  setIds(Utility.ConvertNewLineToComma(e.target.value))
                }
              />
            </Box>
          </Box>
          {(labName && labName === "igi") ?
            <Box
              sx={{
                display: "flex",
                width: "90%",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <Box sx={{ alignSelf: "center", mt: 1, width: "20%", }}>
                <Typography>Priority</Typography>
              </Box>
              <Box
                sx={{
                  alignSelf: "center",
                  width: "50%",
                  mt: 1,
                }}
              >
                <Select menuPlacement="auto"
                  blurInputOnSelect={false}
                  menuPortalTarget={document.body}
                  styles={Constants.Styles}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  options={Constants.IGI_PRIORITIES}
                  value={priority}
                  onChange={(e) => setPriority(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "27%",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  gap: "15px",
                  mt: 1,
                }}
              >
                <Typography>Force Re-Fetch</Typography>
                <Box>
                  <Checkbox
                    onChange={(e) => setForceReFetch(e.target.checked)}
                    size="small"
                    checked={forceReFetch}
                  />
                </Box>
              </Box>
            </Box> : null}
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            startIcon={<SaveIcon />}
            variant="contained"
            sx={{ mr: 2 }}
            onClick={saveHandler}
            type="Submit"
            disabled={ids.length < 1}
          >
            Save
          </LoadingButton>
          <Button variant="contained" color="error" onClick={handleClose} disabled={loading}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
};

export default AddCertificateModal;